<template>
  <HubContainer id="posConfigurationHub">

    <template v-if="moduleActivated.POS && atLeastCompanyAdmin">
      <HubSection icon="icon/hub/printing.svg"
                  :title="$t('printers.title')"
                  :description="$t('printers.description')"
                  :buttonAction="goToPrinterHub">
      </HubSection>

      <HubSection icon="icon/hub/services.svg"
                  :title="$t('order_options.title')"
                  :description="$t('order_options.subtitle')"
                  :buttonAction="goToOrderOptions">
      </HubSection>

      <HubSection icon="icon/hub/settings.svg" v-if="atLeastSuperAdmin"
                  :title="$t('licensing.title')"
                  :description="$t('licensing.description')"
                  :buttonAction="goToLicense">
      </HubSection>

      <HubSection icon="icon/hub/global-settings.svg" v-if="atLeastSuperAdmin"
                  :title="$t('roles.ROLE_POS')"
                  :description="$t('roles.ROLE_POS_description')"
                  :buttonAction="goToRoles">
      </HubSection>

      <HubSection icon="icon/hub/MEV-WEB.svg" v-if="haveMevConfiguration"
                  :title="$t('mev_config.title')"
                  :description="$t('mev_config.subtitle')"
                  :buttonAction="goToMevConfig">
      </HubSection>

      <HubSection icon="icon/hub/visual-configuration.svg"
                  :title="$t('pos_visual_config.title')"
                  :description="$t('pos_visual_config.subtitle')"
                  :buttonAction="goToVisualConfig">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "posConfigurationHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "catering.title";
      this.$store.state.pageIcon = "/icon/nav/inventory.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      haveMevConfiguration() {
        return this.company && this.company.country === "CA" && this.company.region === "QC";
      }
    },

    methods: {
      goToPrinterHub() {
        this.$router.push(this.$router.buildContext("/pos-printer-hub"));
      },
      goToOrderOptions() {
        this.$router.push(this.$router.buildContext("/pos/order-options"));
      },
      goToLicense() {
        this.$router.push(this.$router.buildContext("/licenses"));
      },
      goToRoles() {
        this.$router.push(this.$router.buildContext("/users/ROLE_POS"));
      },
      goToVisualConfig() {
        this.$router.push(this.$router.buildContext("/pos/visual-config"));
      },
      goToMevConfig() {
        this.$router.push(this.$router.buildContext("/pos/mev-config"));
      }
    }
  }
</script>